let buildingRibbonScenarioName: string | undefined;

export function setRibbonScenarioName(name: string | undefined): void {
    buildingRibbonScenarioName = name;
}

export function getRibbonScenarioName(): string | undefined {
    return buildingRibbonScenarioName;
}
